<template>
  <single-panel-page>
    <p>
      We have updated our Privacy Policy and Terms of Service. Please provide
      the necessary agreements to further use Vestbee
    </p>

    <TermsFormOrganizer
      :all-terms-accepted.sync="allTermsAccepted"
      :show-errors="triedToSubmit"
    />

    <div>
      <el-button type="primary" @click="submit">
        Accept
      </el-button>
      <el-button @click="logout">
        Logout
      </el-button>
    </div>
  </single-panel-page>
</template>

<script>
import TermsFormOrganizer from '@/components/users/TermsFormOrganizer'
import { mapState } from 'vuex'
import http from '@/services/http'
import Auth from '@/services/Auth'
import router from '@/routes'

function getInitialErrors() {
  return { non_field_errors: [] }
}

export default {
  name: 'ConfirmAgreements',
  components: {
    TermsFormOrganizer,
  },
  beforeRouteEnter(to, from, next) {
    if (!Auth.getAuthToken()) {
      next({ path: '/' })
    } else next()
  },
  data() {
    return {
      allTermsAccepted: false,
      triedToSubmit: false,
      inProgress: false,
      errors: getInitialErrors(),
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.user.data,
    }),
  },
  methods: {
    async submit() {
      this.triedToSubmit = true
      if (this.user.isOrganizer && !this.allTermsAccepted) {
        this.$message.error('Correct form errors')
        return
      }
      this.inProgress = true
      try {
        const response = await http.postAuthed('/auth/accept-terms')
        if (response) {
          const self = this
          // TODO: for some reason seems like state is undefined if called before
          // user's profile is fetched
          setTimeout(() => {
            if (self.$route.query.next) {
              router.push({ path: self.$route.query.next })
            } else {
              self.$store.dispatch('user/goToDefaultPage')
            }
          }, 500)
        }
        this.clearErrors()
      } catch (error) {
        if (error.response) {
          this.errors = { ...this.errors, ...error.response.data }
        } else {
          throw error
        }
      } finally {
        this.inProgress = false
      }
    },
    logout() {
      this.$store.dispatch('user/logout')
      this.$router.push({ path: '/' })
    },
    clearErrors() {
      this.errors = getInitialErrors()
    },
  },
}
</script>

<style scoped>
p {
  margin-bottom: 30px;
}
</style>
